import React from 'react';

// Components
import AmexSvg from '../../common/components/svgs/AmexSvg';
import DiscoveryCreditCardSvg from '../../common/components/svgs/DiscoveryCreditCardSvg';
import MasterCardSvg from '../../common/components/svgs/MasterCardSvg';
import VisaSvg from '../../common/components/svgs/VisaSvg';

const AMEX = 'amex';
const DISCOVER = 'discover';
const MASTERCARD = 'mastercard';
const VISA = 'visa';

export const checkCreditCard = (_rule, value, callback) => {
  const number = parseInt(value, 10);
  if (
    Number.isNaN(number)
    || (getNumberLength(value) !== 15 && getNumberLength(value) !== 16)
  ) {
    callback('You must specify a valid credit card number.');
  } else {
    callback();
  }
};

const getNumberLength = (number) => number.toString().split('').length;

export const getCreditCardType = (value) => {
  if (!value) {
    return null;
  }

  const firstChar = Number(value.charAt(0));
  if (firstChar === 4) {
    return VISA;
  }
  if (firstChar === 5) {
    return MASTERCARD;
  }
  if (firstChar === 2) {
    return AMEX;
  }
  if (firstChar === 6) {
    return DISCOVER;
  }

  return null;
};

export const creditCards = [
  {
    component: <VisaSvg />,
    type: VISA,
  },
  {
    component: <MasterCardSvg />,
    type: MASTERCARD,
  },
  {
    component: <AmexSvg />,
    type: AMEX,
  },
  {
    component: <DiscoveryCreditCardSvg />,
    type: DISCOVER,
  },
];

export const checkExpiryDate = (_rule, value, callback) => {
  const dateRegex = new RegExp('(0[1-9]|10|11|12)/[0-9]{2}$');
  if (!dateRegex.test(value)) {
    callback('Please enter a valid expiration date in MM/YY format.');
  } else {
    callback();
  }
};

export const checkCVV = (_rule, value, callback) => {
  const number = parseInt(value, 10);
  const allowedLengths = [3, 4];

  if (
    Number.isNaN(number)
    || allowedLengths.indexOf(getNumberLength(value)) === -1
  ) {
    callback('Please enter a valid CVV');
  } else {
    callback();
  }
};
